var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.27734L5.6875 8.71484C5.57812 8.85156 5.41406 8.90625 5.25 8.90625C5.05859 8.90625 4.89453 8.85156 4.78516 8.71484L0.847656 4.77734C0.574219 4.53125 0.574219 4.12109 0.847656 3.875C1.09375 3.60156 1.50391 3.60156 1.75 3.875L5.25 7.34766L12.2227 0.375C12.4688 0.101562 12.8789 0.101562 13.125 0.375C13.3984 0.621094 13.3984 1.03125 13.125 1.27734Z",
    fill: "#004d3a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check-green.188ce8b361f844b9bb48399ae7423cef.svg";
export { ForwardRef as ReactComponent };